import { IPlayerState } from '../reducer.types';
import { trackApiRequestSuccess } from '../actions';

export const trackApiRequestSuccessReducer = (
  state: IPlayerState,
  action: ReturnType<typeof trackApiRequestSuccess>,
) => {
  const { track } = action.payload;

  return {
    ...state,
    tracksById: {
      ...state.tracksById,
      [track.id]: track,
    },
    isTrackApiRequestPending: false,
    trackApiRequestError: null,
  };
};
